export * from './iStaticPageHelper';